<script setup>
import { router, useForm } from '@inertiajs/vue3';
import JetActionMessage from '@/Jetstream/ActionMessage.vue';
import JetButton from '@/Jetstream/Button.vue';
import JetFormSection from '@/Jetstream/FormSection.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetInputError from '@/Jetstream/InputError.vue';
import JetLabel from '@/Jetstream/Label.vue';

// includes we need to front end locale magic
import { useI18n } from 'vue-i18n';
// Get locale as set in cookie
let { locale } = useI18n({ useScope: 'global' });
// This needs removing before pushing.

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";

const props = defineProps({
    team: Object,
    permissions: Object,
});

let team_custom_name = programme.team_custom_name;
if (team_custom_name) {
    if(team_custom_name.constructor.name != 'Object') {
        team_custom_name = JSON.parse(team_custom_name);
    }
}

let default_team_name;

if (locale.value == 'cy') {
    default_team_name = 'tîm';

} else  {
    default_team_name = 'team';
}

let team_name = default_team_name;

if (team_custom_name) {
    team_name =  team_custom_name[locale.value] == null ? default_team_name : team_custom_name[locale.value];
}

const form = useForm({
    name: props.team.name,
});

const updateTeamName = () => {
    form.put(route(urlNamePrefix+'teams.update', props.team), {
        errorBag: 'updateTeamName',
        preserveScroll: true,
    });
};
</script>

<template>
    <JetFormSection @submitted="updateTeamName">
        <template #title>
            <span style="text-transform: capitalize;">{{ $t('teams.update.title', { team_name: team_name }) }}</span>
        </template>

        <template #description>
            {{ $t('teams.update.description', { team_name: team_name }) }}
        </template>

        <template #form>
            <!-- Team Owner Information 
            <div class="col-span-6">
                <JetLabel :value="$t('teams.update.owner', { team_name: team_name })" style="text-transform: capitalize;" />

                <div class="flex items-center mt-2">
                    <img class="w-12 h-12 rounded-full object-cover" :src="team.owner.profile_photo_url" :alt="team.owner.first_name + ' ' + team.owner.last_name">

                    <div class="ml-4 leading-tight">
                        <div>{{ team.owner.first_name }} {{ team.owner.last_name }}</div>
                        <div class="text-gray-700 text-sm">
                            {{ team.owner.email }}
                        </div>
                    </div>
                </div>
            </div>
            -->

            <!-- Team Name -->
            <div style="text-transform: capitalize;" class="col-span-6 sm:col-span-4">
                <JetLabel for="name" :value="$t('teams.update.name', { team_name: team_name })" />

                <JetInput
                    id="name"
                    v-model="form.name"
                    type="text"
                    class="mt-1 block w-full"
                    :disabled="! permissions.canUpdateTeam"
                />

                <JetInputError :message="form.errors.name" class="mt-2" />
            </div>
        </template>

        <template v-if="permissions.canUpdateTeam" #actions>
            <JetActionMessage :on="form.recentlySuccessful" class="mr-3">
                {{ $t('teams.update.success') }}
            </JetActionMessage>

            <JetButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                {{ $t('teams.update.submit') }}
            </JetButton>
        </template>
    </JetFormSection>
</template>
